import { helper } from '@myrealtrip/frontend-weblog';
import { ButtonGeneral, Text } from '@myrealtrip/web-ui';

import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import { WeblogEventName, WeblogPageCategory, WeblogScreenName } from '~constants/weblog';

import type { TransportationProduct } from '~models/Transportation/PointToPointTicket';

const { sendClickLog } = helper;

interface Props {
  product: TransportationProduct;
  sectionTitle: string;
  sectionVerticalIndex: number;
  itemIndex: number;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const CTA = ({ product, sectionTitle, sectionVerticalIndex, itemIndex, onClick }: Props) => {
  const { colors } = useTheme();

  const { salePrice } = product ?? {};

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    sendClickLog({
      pageCategory: WeblogPageCategory.EUROPE_TRAIN_TICKET_MAIN,
      screenName: WeblogScreenName.EUROPE_TRAIN_TICKET_MAIN,
      eventName: WeblogEventName.RECOMMENDED_PASS,
      itemKind: 'offer',
      itemId: product.gid,
      itemName: product.title,
      sectionTitle: sectionTitle,
      sectionVerticalIndex,
      itemVerticalIndex: itemIndex,
    });

    onClick(e);
  };

  return (
    <Container>
      <PriceContainer>
        <Price as="p" typography="headlineBold18">
          {Math.round(salePrice).toLocaleString()}원
        </Price>
        <Text as="p" typography="captionNormal14" color={colors.gray.s500}>
          수수료 포함
        </Text>
      </PriceContainer>

      <CTAButton priority="primaryOpt" shape="rectangle" size="xSmall" onClick={handleClick}>
        선택하기
      </CTAButton>
    </Container>
  );
};

export default CTA;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const PriceContainer = styled.div``;

const Price = styled(Text)`
  margin: 0 0 2px;
`;

const CTAButton = styled(ButtonGeneral)`
  border-radius: 8px;
`;
